// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_A9ojD","breadcrumbs":"index_breadcrumbs_mYmvA"};